/** The page a report email's button opens, which exchanges the secret in its fragment for a session. */
export const MAGIC_LINK_PATH = "/report-link"

const FRAGMENT_KEY = "t"
const SECRET_PATTERN = /^[A-Za-z0-9_-]+$/

/** The secret from "#t=...", or null when the fragment holds nothing that could be one. */
export function readMagicLinkSecret(hash: string): string | null {
    const prefix = `#${FRAGMENT_KEY}=`
    if (!hash.startsWith(prefix)) return null
    const secret = hash.slice(prefix.length)
    return SECRET_PATTERN.test(secret) ? secret : null
}

const LINK_WITH_SECRET = /(\/report-link(?:\?[^#"\\\s]*)?)#t=[A-Za-z0-9_-]*/g

/**
 * Anything that records a url (analytics above all) with the secret taken out. The secret is a
 * credential for a month, so it must not end up in a tool the team can search.
 */
export function scrubMagicLinkSecret<T>(value: T): T {
    return JSON.parse(JSON.stringify(value).replace(LINK_WITH_SECRET, "$1"))
}
